<template>
  <div class="ps-page--shop" id="shop-sidebar">
    <div class="container">
      <div class="ps-layout--shop">
        <div class="ps-layout__left">
          <aside class="widget widget_shop">
            <figure class="sizes">
              <h4 v-if="isEn==true" class="widget-title">SEARCH BY DIVISION</h4>
              <h4 v-if="isEn==false" class="widget-title">RECHERCHER PAR DIVISION</h4>
              <div >
                <input type="checkbox" id="all" value="" v-model="checkedAll" @change="tickAll()">
                <label v-if="isEn==true" for="mike">All your divisions</label>
                <label v-if="isEn==false" for="mike">Toutes vos divisions</label>
              </div>
              <div v-for="division in divisions" :key="division.no_division" >
                <input type="checkbox" :id="division.label" :value="division.no_division" v-model="checkedDivisions" @change="tickDivision()">
                <label :for="division.label">{{division.label}}</label>
              </div>
              <br/><br/>
              <h4 v-if="isEn==true" class="widget-title">PRODUCTS IN STOCK</h4>
              <h4 v-if="isEn==false" class="widget-title">PRODUITS EN STOCK</h4>
              <div >
                <input type="checkbox" :id="stock.label_en" :value="stock.value" v-model="inStock" @change="tickFilter()">
                <label v-if="isEn==true" :for="stock.label_en"> Only in stock</label>
                <label v-if="isEn==false" :for="stock.label_en"> Seulement en stock</label>
              </div>
              <div >
                <input type="checkbox" :id="newproduct.label_en" :value="newproduct.value" v-model="isNewProduct" @change="tickFilter()">
                <label v-if="isEn==true" :for="newproduct.label_en"> Only new product</label>
                <label v-if="isEn==false" :for="newproduct.label_en"> Seulement les nouveaux produits</label>
              </div>
            </figure>
          </aside>
        </div>
        <div class="ps-layout__left__mobile">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h2 class="mb-0">
                    <button v-if="isEn==true" class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      SEARCH BY DIVISION
                    </button>
                    <button v-if="isEn==false" class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      RECHERCHER PAR DIVISION
                    </button>
                    <span class="arrow"></span>
                  </h2>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    <div>
                      <input type="checkbox" id="all" value="" v-model="checkedAll" @change="tickAll()">
                      <label v-if="isEn==true" for="mike">All your divisions</label>
                      <label v-if="isEn==false" for="mike">Toutes vos divisions</label>
                    </div>
                    <div v-for="division in divisions" :key="division.no_division" >
                      <input type="checkbox" :id="division.label" :value="division.no_division" v-model="checkedDivisions" @change="tickDivision()">
                      <label :for="division.label">{{division.label}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button v-if="isEn==true" class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                      PRODUCTS
                    </button>
                    <button v-if="isEn==false" class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                      PRODUITS
                    </button>
                    <span class="arrow"></span>
                  </h2>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                  <div class="card-body">
                    <div>
                      <input type="checkbox" :id="stock.label_en" :value="stock.value" v-model="inStock" @change="tickFilter()">
                      <label v-if="isEn==true" :for="stock.label_en"> Only in stock</label>
                      <label v-if="isEn==false" :for="stock.label_en"> Seulement en stock</label>
                    </div>
                  </div>
                  <div>
                      <input type="checkbox" :id="newproduct.label_en" :value="newproduct.value" v-model="isNewProduct" @change="tickFilter()">
                      <label v-if="isEn==true" :for="newproduct.label_en"> Only new product</label>
                      <label v-if="isEn==false" :for="newproduct.label_en"> Seulement les nouveaux produits</label>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="ps-layout__right">
          <div class="ps-shopping ps-tab-root">
            <div class="ps-shopping__header">
              <p v-if="isEn==true"><strong> {{products.length}}</strong> Products found</p>
              <p v-if="isEn==false"><strong> {{products.length}}</strong> Produits Retrouvés</p>
            </div>
            <div class="ps-tabs">
              <div class="ps-tab active" id="tab-1">
                <div class="ps-shopping-product">
                  <div v-if="noRecord" class="alert alert-primary" role="alert">
                    {{msg}}
                  </div>
                  <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div>
                  <div class="row">
                    <div v-for="product in displayedPosts" :key="product.id + Math.random()" class="col col-lg-4 col-md-4 col-sm-6 col-6 ">
                      <div class="ps-product">
                        <div class="ps-product-hover">
                          <div class="search-button">
                            <button data-toggle="modal" v-on:click="open_image_popup(product)" data-target="#popupModal">
                              <img :src="searchImg" alt="search">
                            </button>
                          </div>
                          <div class="ps-product-selection">
                            <button type="button" @click="decrease_quanity(product)" class="ps-product-quantity__decrement">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                <path d="M4 7h8v2H4z"></path>
                              </svg>
                            </button>
                            <!-- <div contenteditable="true" class="ps-product-quantity"  v-model="quantity" aria-label="quantity"></div> -->

                            <input  class="ps-product-quantity" v-bind:id="product.unique_code" value="1" type="number" min="0"  aria-label="quantity" >

                            <button type="button" @click="increase_quanity(product)" class="ps-product-quantity__increment" :disabled="reachedLimit" >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                <path d="M12 7H9V4H7v3H4v2h3v3h2V9h3z"></path>
                              </svg>
                            </button>

                          </div>
                          <ul class="ps-product__actions">
                            <button v-if="isEn==true" v-on:click="add_to_cart(product)"  type="button" class="btn">Add to cart</button>
                            <button v-if="isEn==false" v-on:click="add_to_cart(product)"  type="button" class="btn">Ajouter au panier</button>
                          </ul>
                        </div>
                        <div class="ps-product__thumbnail">
                          <a v-if="product.image_url!='----'"><img :src="versionning(product, 'image_url')" alt=""></a>
                          <a v-if="product.image_url=='----'"><img :src="default_img" alt=""></a>
                          <!-- Products quantity choose -->
                        </div>
                        <div class="ps-product__container">
                          <p class="ps-product__vendor" href="#">{{product.unique_code}}</p>
                          <p class="ps-product__title" href="#">{{product.description}}</p>
                          <div class="ps-product__content">
                            <p v-if="isEn==true" class="ps-product__price">Quantity: {{product.available_quantity}} </p>
                            <p v-if="isEn==false" class="ps-product__price">Quantité: {{product.available_quantity}} </p>
                          </div>
                          <!--<div class="ps-product__content hover"><a class="ps-product__title" href="#">{{product.description}}</a>
                              <p class="ps-product__price"></p>
                          </div>-->
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="ps-pagination">
                  <ul class="pagination">
                    <li v-if="isEn==true"><a v-if="page!=1" @click="prev_clicked()"><i class="icon-chevron-left"></i>Previous Page</a></li>
                    <li v-if="isEn==false"><a v-if="page!=1" @click="prev_clicked()"><i class="icon-chevron-left"></i>Page précédente</a></li>
                    <li v-for="pageNumber in pages.slice(page-1, page+5)" :key="pageNumber" @click="assign_page(pageNumber)" v-bind:id="pageNumber"><a>{{pageNumber}}</a></li>

                    <li v-if="isEn==true"><a @click="next_clicked()" v-if="page < pages.length" >Next Page<i class="icon-chevron-right"></i></a></li>
                    <li v-if="isEn==false"><a @click="next_clicked()" v-if="page < pages.length" >Page Suivante<i class="icon-chevron-right"></i></a></li>
                  </ul>
                </div>
              </div>
              <div class="ps-tab" id="tab-2">
                <div class="ps-shopping-product">
                  <div v-for="product in displayedPosts" :key="product.id + Math.random()" class="ps-product ps-product--wide">
                    <div class="ps-product__thumbnail">

                      <a v-if="product.image_url!='----'"><img :src="versionning(product, 'image_url')" alt=""></a>
                      <a v-if="product.image_url=='----'"><img :src="default_img" alt=""></a>
                    </div>
                    <div class="ps-product__container">
                      <div class="ps-product__content"><a class="ps-product__title" href="#">{{product.description}}</a>
                        <p class="ps-product__vendor">Sold by:<a href="#">{{product.unique_code}}</a></p>
                        <ul class="ps-product__desc">
                          <li> </li>
                          <li> </li>

                        </ul>
                      </div>
                      <div class="ps-product__shopping">
                        <p class="ps-product__price"></p><a v-on:click="add_to_cart(product)" class="ps-btn" href="#products">Add to cart</a>
                        <ul class="ps-product__actions">
                          <li><a href="#"><i class="icon-heart"></i> Wishlist</a></li>
                          <li><a href="#"><i class="icon-chart-bars"></i> Compare</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="ps-pagination">
                  <ul class="pagination">
                    <li><a href="#">Previous Page<i class="icon-chevron-left"></i></a></li>
                    <li class="active"><a href="#">1</a></li>
                    <li><a href="#">2</a></li>
                    <li><a href="#">3</a></li>
                    <li><a href="#">Next Page<i class="icon-chevron-right"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade popup" id="popupModal" tabindex="-1" role="dialog" aria-labelledby="popupModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body-image">
              <img :src="testImage" alt="search">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DataService from "@/services/DataService";
  export default {
    name: 'Products',
    props: ['search_on','search_obj','language'],
    data () {
      return {
        msg: '',
        failed: false,
        key: 0,
        search_trigg : this.search_on,
        li_comp : '',
        products:[],
        products_all:[],
        divisions:[],
        checkedDivisions:[],
        checkedAll:true,
        token:localStorage.getItem('token'),
        isEn: true,
        cart:[],
        lang : this.language,
        noRecord:false,
        stock:{label_en:"Only in stock",label_fr:"Seulement en stock",value:false},
        newproduct:{label_en:"New product",label_fr:"Nouveau produit",value:false},
        inStock:true,
        isNewProduct:false,
        default_img : require('../assets/default.jpeg'),
        searchImg : require('../assets/img/search.svg'),
        testImage: require('../assets/img/bg/subscribe.jpg'),
        //added for pagination
        page: 1,
        perPage: 20,
        pages: [],
        reachedLimit: false // if false, user can increase the product quantity for order. Otherwise, he'll be blocked
      }
    },

    methods: {

      user_products(token){


        var dataa = {};
        console.log(token);
         console.log(  JSON.stringify(dataa));
        DataService.user_products(dataa,token)
          .then(response => {

            console.log(response.data);
            //this.message = response.data.message;
            //this.products = response.data.my_products;
            this.divisions = response.data.my_divisions;
            this.products = [];
            this.products_all = [];
            response.data.my_products.forEach(product => {
              product.minimum_quantity = 1;
              this.products_all.push(product);
              if(this.inStock){
                if(product.available_quantity!="0"){
                     this.products.push(product);
                }

              }else{
                this.products.push(product);
              }

            });
            if(this.products.length==0){
              this.msg = 'No products available in  your divisions';
              this.noRecord = true;
            }

            console.log("printing the checkedDivisions");
            response.data.my_divisions.forEach(element => {
              this.checkedDivisions.push(element.no_division);

            });

            console.log(this.checkedDivisions);

          })
          .catch(e => {
            console.log(e.response);
            //this.message = error.response.data.errors[0];
            //console.log(error.response.data.errors);


          if(e!=undefined){

           if(e.response.status == 404){

            this.msg = "Route nod found";
          }else if(e.response.status == 401){
             this.$router.push('/login');
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }
          this.failed = true;

          }
          });
      },

      open_image_popup: function (item) {

       if(item.image_url=='----'){
        this.testImage = this.default_img;
       }else{
        this.testImage = this.versionning(item, "image_url");
       }
      },

      quantity_keyup(event,item){

        console.log("a key has been pressed");
        event.preventDefault();

        console.log(event);

        const string_quantity = item.minimum_quantity.toString();
        const numbers_arr = ['0','1','2','3','4','5','6','7','8','9'];
        if (event.key == "Backspace") {
           if(window.getSelection()){
              let selection = window.getSelection();
              selection.deleteFromDocument();
              item.minimum_quantity = 0;
              string_quantity == '0';

           }else{

          const new_value = string_quantity.slice(0, -1);
          item.minimum_quantity=  parseInt(new_value);
          console.log(new_value.length);
          if(new_value.length==0){
            item.minimum_quantity = 0;
            string_quantity == '0';
          }
        }

        }else if(  numbers_arr.indexOf(event.key) !== -1){

            if(item.minimum_quantity==0){

            string_quantity == '';
          }
          const new_value = string_quantity.concat(event.key);
          item.minimum_quantity = parseInt(new_value);
        }else{

        }


      },


      search_user_products(dataa){

        this.noRecord = false;
        var token = localStorage.getItem('token');
        console.log(token);
        console.log("===== Printing the dataa value =====");
        console.log(dataa);
         console.log(  JSON.stringify(dataa));
          console.log("===== Printing the page no =====");
          console.log(this.page); this.page=1;

        DataService.products_search(dataa,token)
          .then(response => {

            console.log(response.data);
            this.products = [];
            this.products_all =[];
            this.divisions=[];
            this.divisions = response.data.my_divisions;


            response.data.my_products.forEach(product => {
              product.minimum_quantity = 1;
              this.products_all.push(product);
              if(this.inStock){
                if(product.available_quantity!="0"){
                     this.products.push(product);
                }

              }else{
                this.products.push(product);
              }


            });
            this.setPages();
            if(this.products.length==0){
              this.msg = 'No products available ';
              this.noRecord = true;
            }

            this.checkedDivisions=[];
            console.log("printing the checkedDivisions");
            response.data.my_divisions.forEach(element => {
              this.checkedDivisions.push(element.no_division);

            });
          })
          .catch(error => {
            console.log(error.response);
            //this.message = error.response.data.errors[0];
          });
      },


      versionning(obj, field){
        console.log(obj[field]);
        var imageUrl = obj[field] + "?v=" + new Date(obj['updated_at']).getTime();
        return imageUrl;
      },

      add_to_cart(item){

        this.failed = false;
        this.noRecord = false;
        let qtvalue =  document.getElementById(item.unique_code).value;
        console.log(qtvalue);

        if(qtvalue=="" || qtvalue==""){
          document.getElementById(item.unique_code).value = "1";
          item.minimum_quantity = 1;
        }else{
          item.minimum_quantity = parseInt(qtvalue);
        }



        if(item.available_quantity==0){
          if(this.isEnglish()){

           this.msg = "The product you are trying to add is not available";

          }else{

           this.msg = "Le produit que vous essayez d'ajouter n'est pas disponible";

          }

          this.$parent.eventmsg = this.msg;
          this.$parent.showeventmsg = false;
          this.$parent.showerrormsg = true;

          setTimeout(() => this.$parent.showerrormsg = false, 3000);

          // this.failed = true;
        }else{

          if(this.check_cart_array(item)){

          if(this.isEnglish()){

           this.msg = "Sorry, this product is already in your cart.";

          }else{

           this.msg = "Désolé, ce produit est déjà dans votre panier.";

          }

            this.$parent.eventmsg = this.msg;
            this.$parent.showeventmsg = false;

            this.$parent.showerrormsg = true;

            setTimeout(() => this.$parent.showerrormsg = false, 3000);

            //this.failed = true;
          }else if(item.minimum_quantity > item.available_quantity){
             console.log("item.available_quantity :"+item.available_quantity);
             console.log("item.minimum_quantity :"+item.minimum_quantity );

            if(this.isEnglish()){

              this.msg = "Sorry, the quantity you requested is not available.";

            }else{

                this.msg = "Désolé, la quantité que vous avez demandée n'est pas disponible.";

            }

            this.$parent.eventmsg = this.msg;
            this.$parent.showeventmsg = false;

            this.$parent.showerrormsg = true;

            setTimeout(() => this.$parent.showerrormsg = false, 3000);

            // this.failed = true;
          }else{
            this.noRecord = false;
            console.log("Printing the item being added to the basket");

            if(this.isEnglish()){

              this.msg = 'Successfully added '+ item.minimum_quantity +' '+item.description +' to the cart';

            }else{

                this.msg = 'Le produit '+ item.minimum_quantity +' '+item.description +' a été ajouté au panier.';

            }


            this.$parent.eventmsg = this.msg;

            this.$parent.showerrormsg = false;
            this.$parent.showeventmsg = true;

            setTimeout(() => this.$parent.showeventmsg = false, 3000);

            //this.noRecord = true;
            console.log(item);
            item.id  = item.id + Date.now();
            this.$parent.cart.push(item);
            localStorage.setItem('basket',JSON.stringify(this.$parent.cart));
            // item.minimum_quantity = 1;
          }
        }


      },

      check_cart_array(item){

        var  belong_to_cart = false;
        this.cart =   this.$parent.cart;
        console.log("printing existing product :::");
        console.log(this.cart);
        console.log("printing new product :::");
        console.log(item);
        this.cart.forEach(function(crt){
         // if(crt.id==item.id){
      if(crt.no_product==item.no_product){
            belong_to_cart = true;
          }

        });

        return belong_to_cart;
      },


      tickAll(){


        console.log(this.checkedAll);
        this.checkedDivisions=[];
        this.divisions.forEach(element => {
          this.checkedDivisions.push(element.no_division);

        });
        if(this.checkedAll==true){
          this.tickDivision();
        }else if(this.checkedAll==false){
          this.checkedDivisions=[];
          this.products = [];
        }

      },

      tickInStock(){
        console.log("printing the inStock value");
        console.log(this.inStock);
      },

      tickNewProduct(){
        console.log("printing the inStock value");
        console.log(this.IsNewProduct);
      },


      increase_quanity(item){

        this.noRecord = false;

        item.minimum_quantity = parseInt(document.getElementById(item.unique_code).value);
        item.minimum_quantity++;
        document.getElementById(item.unique_code).value = item.minimum_quantity.toString();
        this.reachedLimit = Number(item.minimum_quantity) >= Number(item.available_quantity)
      },

      decrease_quanity(item){

        this.noRecord = false;
        if(item.minimum_quantity > 1){

           item.minimum_quantity = parseInt(document.getElementById(item.unique_code).value);
           item.minimum_quantity--;
           document.getElementById(item.unique_code).value = item.minimum_quantity.toString();

        }

      },

      tickFilter(){

        if(this.checkedDivisions.length!=this.divisions.length){
          this.checkedAll = false;
        }else{
          this.checkedAll = true;
        }

        var prods =   this.products_all;
        this.products=[];
        prods.forEach(product => {
              product.minimum_quantity = 1;

              if(this.inStock){
                if(product.available_quantity!="0"){
                     this.products.push(product);
                }

              }else{
                this.products.push(product);
              }


            });

            //get date 3 months earlier
            var earlier = new Date();
              earlier.setMonth(earlier.getMonth() - 3);
              var tmpProducts = [];

              this.products.forEach((product, index) => {
                    product.minimum_quantity = 1;             
                    if(this.isNewProduct){                      
                      if(new Date(product.created_at) > earlier){
                        console.log("entrer");
                        tmpProducts.push(product);
                      }

                    }else{
                      tmpProducts.push(product);
                    }
                  });

            this.products = tmpProducts;        
      },

      /*tickOnlyNewProduct(){

        if(this.checkedDivisions.length!=this.divisions.length){
          this.checkedAll = false;
        }else{
          this.checkedAll = true;
        }

        var prods =   this.products_all;
        this.products=[];

        //get date 3 months earlier
        var earlier = new Date();
        earlier.setMonth(earlier.getMonth() - 3);
        console.log(earlier);

        prods.forEach(product => {
              product.minimum_quantity = 1;             
              if(this.isNewProduct){
                console.log(product);
                if(product.created_at > earlier){
                    this.products.push(product);
                }

              }else{
                this.products.push(product);
              }
            });
      },*/



      galavanta(){

        console.log(this.checkedDivisions);

        if(this.checkedDivisions.length!=this.divisions.length){

          this.checkedAll = false;

        }else{

          this.checkedAll = true;

        }

        var prods= this.products_all;
        var divs = this.checkedDivisions;
        this.products = [];

        prods.forEach(product => {

            product.minimum_quantity = 1;

            if(divs.includes(product.no_division)){

              if(this.inStock){

                  if(product.available_quantity!="0"){
                    this.products.push(product);

                  }

              }else{

                     this.products.push(product);

              }
          }


        });

        // this.setPages();

      },


      tickDivision(){

        if(this.checkedDivisions.length!=this.divisions.length){
          this.checkedAll = false;
        }else{
          this.checkedAll = true;
        }
        this.noRecord = false;
        console.log(this.checkedDivisions);
        var dataa = {checked_divisions:this.checkedDivisions,type:this.search_obj.type,
        word:this.search_obj.word};

        console.log("printing checkeddiv to be sent");
        console.log(dataa);
        console.log(  JSON.stringify(dataa));

        DataService.user_products_per_division(dataa,this.token)
          .then(response => {

            console.log(response.data);
            this.products = [];
            this.products_all=[];
            response.data.my_products.forEach(product => {
              product.minimum_quantity = 1;
              this.products_all.push(product);


                if(this.inStock){

                  if(product.available_quantity!="0"){
                    this.products.push(product);

                  }

              }else{

                     this.products.push(product);

              }

            });
            this.setPages();
            if(this.products.length==0){

              if(this.isEnglish()){
                this.msg = 'No products available for selected divisions';
              }else{
                this.msg = 'Aucun produit disponible pour les divisions sélectionnées';
              }

              this.noRecord = true;
            }


          })
          .catch(error => {
            console.log(error.response);
            //this.message = error.response.data.errors[0];
            //console.log(error.response.data.errors);
          });

      },


      next_clicked(){

        this.page = this.page+1;
        // document.getElementById(this.page).classList.add("active");

        console.log("printing page value :");

        console.log(this.page);

        console.log("printing pages value :");

        console.log(this.pages);
      },

      prev_clicked(){

        this.page = this.page-1;

      },

      assign_page(pageNumber){
        this.page = pageNumber;
      },

      isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

      },


      setPages () {

        this.pages = [];
        let numberOfPages = Math.ceil(this.products.length / this.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
        console.log("setting pages:");
        console.log(this.pages);

      },

      paginate (products) {
        let page = this.page;
        let perPage = this.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);


        return  products.slice(from, to);
      },
    },


// added for pagination
    computed: {
      displayedPosts () {

        return this.paginate(this.products);
      }
    },

// added for pagination
    watch: {

      products () {

        this.setPages();
        //

        return this.paginate(this.products);
      },

      search_on:function(){
        console.log("value of search_on is :"+this.search_on);


        if(this.search_on){
          this.$parent.search_on = false;
          this.search_user_products(this.search_obj);


        }

        console.log(this.search_obj);
      },

      page: function (val) {
        setTimeout(() => {
          let next = this.page+1;
          document.getElementById(next).classList.remove("active");
          document.getElementById(this.page).classList.add("active");
          console.log("the prev page number :");
          console.log(next);
          console.log("the current page number :");
          console.log(this.page);
        }, 1000);

      },

      language:function(){
        this.lang = this.language;
        this.isEn = this.isEnglish();
        console.log("language value has changed in [products] component");

      },

    },

    created(){

      this.li_comp = document.getElementById(this.page);
      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login').catch(()=>{ console.log("catching router error")});

      }else{

        if(localStorage.getItem('caller_role')=='Basic'){

          //this.$router.push('/products');
          this.user_products(localStorage.getItem('token'));
          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');

        }else{

          console.log("=====printing search_on for products=====");
          console.log(this.search_on);
          console.log("=====printing search_obj for products=====");
          console.log(this.search_obj);

          if(this.search_on){

            this.$parent.search_on = false;
            this.search_on = false;
            this.search_user_products(this.search_obj);


          }else{

            this.user_products(localStorage.getItem('token'));
            this.$parent.token = localStorage.getItem('token');
            this.token = localStorage.getItem('token');
          }

        }
      }
    },

    // added for pagination
    filters: {
      trimWords(value){
        return value.split(" ").splice(0,20).join(" ") + '...';
      }
    },


    mounted(){
       this.isEn = this.isEnglish();
      console.log("printing loggedin value in mounted :"+this.$parent.loggedin);
      console.log("printing token value in home component :"+localStorage.getItem('token'));

    },
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .modal-backdrop {
    z-index: 100000;
  }
  .modal {
    z-index: 100001;
  }
  .modal-open .modal {
    padding-right: 0 !important;
  }
  .modal-content {
    position: relative;
  }
  .modal-content .modal-header {
    width: 30px;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    border-bottom: none;
    padding: 0 !important;
  }
  .modal-content .modal-header button {
    width: 100%;
    height: 100%;
    font-size: 22px;
    margin: 0 !important;
    z-index: 10;
    padding: 0 !important;
  }
  .modal-content .modal-body {
    width: 100%;
    height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 15px !important;
  }
  .modal-content .modal-body .modal-body-image {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 20px;
}
 
.modal-content .modal-body .modal-body-image img {
  width: auto;
  height: 100%;
  object-fit: cover;
}
aside.widget_shop .sizes {
  margin-top: 0;
}
@media screen and (max-width: 768px) {
  .modal-content {
    width: 100%;
  }
  .modal-content .modal-body {
    width: 100%;
    height: 350px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Products.vue